import React, { useState } from "react";
import { useNewUser } from "../../APIContext/NewUserContext";
import { Calendar } from "primereact/calendar";



/* ---------- Dropdown Data ---------- */

const jerseySizes = [
  { label: "Small", value: "S" },
  { label: "Medium", value: "M" },
  { label: "Large", value: "L" },
  { label: "Extra Large", value: "XL" },
  { label: "Youth Small", value: "YS" },
  { label: "Youth Medium", value: "YM" },
  { label: "Youth Large", value: "YL" },
];

const gradeList = [
  { label: "Kindergarten", value: "Kindergarten" },
  { label: "1st", value: "1st" },
  { label: "2nd", value: "2nd" },
  { label: "3rd", value: "3rd" },
  { label: "4th", value: "4th" },
  { label: "5th", value: "5th" },
  { label: "6th", value: "6th" },
  { label: "7th", value: "7th" },
  { label: "8th", value: "8th" },
  { label: "High School", value: "High School" },
  { label: "College", value: "College" },
  { label: "Professional", value: "Professional" },
];

const genderList = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: "Other", value: "other" },
];



export const GuestView = ({packageID}) => {
    const { addToCart } = useNewUser();


    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        gender: "",
        date_of_birth: "",
        grade: "",
        jersey_size: "",
        school_name: "",
    });

    const handleDateChange = (e) => {
        const dob = e.value;
        if (!dob) return;

        const today = new Date();
        const age =
        today.getFullYear() -
        dob.getFullYear() -
        (today.getMonth() < dob.getMonth() ||
        (today.getMonth() === dob.getMonth() && today.getDate() < dob.getDate())
            ? 1
            : 0);

        const year = dob.getFullYear();
        const month = String(dob.getMonth() + 1).padStart(2, "0");
        const day = String(dob.getDate()).padStart(2, "0");

        const formattedDOB = `${year}-${month}-${day}`;

        setFormData((prev) => ({
        ...prev,
        date_of_birth: formattedDOB
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = () => {
        const payload = {
            package_ids: [Number(packageID)],
            player: formData
        };
        addToCart(payload);
        
    };

  return (
        <> 
            <div className="add-child-form">
            {/* Name */}
            <div className="form-row">
                <div className="form-group">
                <label className="black-text-clip">First Name</label>
                <input
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                    placeholder="Enter first name"
                />
                </div>

                <div className="form-group">
                <label className="black-text-clip">Last Name</label>
                <input
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleChange}
                    placeholder="Enter last name"
                />
                </div>
            </div>

            {/* Gender & DOB */}
            <div className="form-row">
                <div className="form-group">
                <label className="black-text-clip">Gender</label>
                <select
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    className=""
                >
                    <option value="">Select gender</option>
                    {genderList.map((g) => (
                    <option key={g.value} value={g.value}>
                        {g.label}
                    </option>
                    ))}
                </select>
                </div>

                <div className="form-group">
                <label className="black-text-clip">Date of Birth (MM-DD-YYYY)</label>
                    <Calendar
                    placeholder="Date of Birth"
                    value={
                        formData.date_of_birth ? new Date(formData.date_of_birth) : null
                    }
                    onChange={handleDateChange}
                    showIcon
                    dateFormat="mm-dd-yy"
                    className="calesndr-cstm"
                    maxDate={new Date()}
                    />
                </div>
            </div>

            {/* Grade & Jersey */}
            <div className="form-row">
                <div className="form-group">
                <label className="black-text-clip">Grade</label>
                <select
                    name="grade"
                    value={formData.grade}
                    onChange={handleChange}
                    className=""
                >
                    <option value="">Select grade</option>
                    {gradeList.map((g) => (
                    <option key={g.value} value={g.value}>
                        {g.label}
                    </option>
                    ))}
                </select>
                </div>

                <div className="form-group">
                <label className="black-text-clip">Jersey Size</label>
                <select
                    name="jersey_size"
                    value={formData.jersey_size}
                    onChange={handleChange}
                    className=""
                >
                    <option value="">Select size</option>
                    {jerseySizes.map((s) => (
                    <option key={s.value} value={s.value}>
                        {s.label}
                    </option>
                    ))}
                </select>
                </div>
            </div>

            {/* School */}
            <div className="form-row">
                <div className="form-group full-width">
                <label className="black-text-clip">School Name</label>
                <input
                    name="school_name"
                    value={formData.school_name}
                    onChange={handleChange}
                    placeholder="Enter school name"
                />
                </div>
            </div>
            </div>
            <div className="p-submit-button-container">
            <button className="p-submit-button" onClick={handleSubmit}>
                Add To Cart {" "}
                <i className="ri-shopping-cart-2-fill cart-icon"></i>
            </button>
            </div>
        </>
     
  );
};

export default GuestView;
